(function(requirejs) {
  "use strict";

  requirejs.config({
    baseUrl: "/assets/javascripts",
    paths: {
      "vue": "../vue",
      "vue.runtime": ["//cdn.jsdelivr.net/webjars/vue/2.5.16/vue.runtime.min"],
      "jquery": ["//cdn.jsdelivr.net/webjars/jquery/3.3.1-2/jquery.min"],
      "bootstrap": ["//cdn.jsdelivr.net/webjars/bootstrap/4.1.3/js/bootstrap.bundle.min"],
      "lodash": ["//cdn.jsdelivr.net/webjars/lodash/4.17.4/lodash.min"],
      "lightbox": "../lightbox/ekko-lightbox"
    }
  });

  requirejs.onError = function(err) {
    console.log(err);
  };

  define([
    "vue.runtime",
    "jquery",
    "bootstrap",
    "lodash",
    "lightbox"
  ]);

})(requirejs);

